import React from 'react'
import Link from 'gatsby-link'

import './index.scss'

const Header = () => (
	<div className="alert">
		<div className="alert--inner">
			<p>HBO has decided to cease operation of the HBO UK, FR, DE, & EU Shops. We are no longer offering merchandise for sale through these portals. Below, you can find out about other HBO products and how to stay connected to your favorite HBO shows.</p>
			<p className="sub">For any queries on recently purchased merchandise, please contact Customer Service listed at the bottom of the page.</p>
		</div>
	</div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js